import { render, staticRenderFns } from "./RankPage.vue?vue&type=template&id=82ee2b0a"
import script from "./js/rank.js?vue&type=script&lang=js&external"
export * from "./js/rank.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports